import { render, staticRenderFns } from "./IntervalAnonymisationField.vue?vue&type=template&id=0917c930&"
import script from "./IntervalAnonymisationField.vue?vue&type=script&lang=ts&"
export * from "./IntervalAnonymisationField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports